import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import routes from './routes'
// import storge from 'good-storage'

import 'nprogress/nprogress.css'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach((to, from, next) => {
  NProgress.start()

  if (to.name === '404') {
    if (from.name === 'notFound') {
      NProgress.done()
    }
    next('/404')
  } else {
    next()
    // 判断本地是否已存储 company:{code:xxx}
    // if (to.meta.needCompnyCode) {
    //   const company = storge.get('company')
    //   company && company.code ? next() : router.push({ name: 'client-center' })
    // }
    // else {
    //   next()
    // }
  }
})

router.afterEach(() => {
  NProgress.done()
})

export default router
